import config from "@/config"
import http from "@/utils/request";
import { getLanguage } from "@/locales";

export default {
	token: {
		url: `${config.API_URL}/lqa-game/oauth/token`,
		name: "登录获取TOKEN",
		post: function(data={}){
			const params = {
				grant_type: "password",
				client_secret: "159357",
				client_id: "lqa_game",
			};
			const body = { ...data, lang: getLanguage() }
			return http.post(this.url, body, { params });
		}
	},
	retoken: {
		url: `${config.API_URL}/lqa-game/oauth/token`,
		name: "登录获取TOKEN",
		post: function(data={}){
			const params = {
				grant_type: "refresh_token",
				client_secret: "159357",
				client_id: "lqa_game",
			};
			const body = { ...data, lang: getLanguage() }
			return http.post(this.url, body, { params });
		}
	},
	flushLang:{
		url: `${config.API_URL}/lqa-game/system/language/data/updateLang?lang=`,
		name: "登录获取TOKEN",
		post: function(param){
			return http.post(this.url+param);
		}
	}
}
